// extracted by mini-css-extract-plugin
export default {"product":"Product_product__C0svh","description":"Product_description__LcNlu"};